"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonMaskMoveType = void 0;
const Enums_1 = require("../Plugins/PolygonMask/Enums");
Object.defineProperty(exports, "PolygonMaskMoveType", { enumerable: true, get: function () { return Enums_1.MoveType; } });
